<template>
  <div
    v-if="visible"
    class="file-drop-container"
    @mousemove="createTrail"
    @dragover="createTrailOnDrag"
    @drop.prevent="handleDrop"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
  >
    <template v-if="!isLoading" >
      <!-- 原有内容保持不变 -->
      <div class="content-area" :class="{ 'drag-over': isDragOver }">

        <div class="header">
          <h1>Ai文件导入<i class="el-icon-close" @click="close"></i></h1>
          <p>将文件拖入此区域，松开文件开始Ai分析导入</p>
        </div>

        <div class="drop-zone" :class="{ 'active': isDragOver }">
          <div class="drop-content">
            <div class="drop-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14,2 14,8 20,8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10,9 9,9 8,9"></polyline>
              </svg>
            </div>
            <h3>拖放文件到这里</h3>
            <p>支持Excel、PDF、Txt类型文件</p>
          </div>
        </div>

        <!-- <div class="file-list" v-if="files.length > 0">
          <h3>已选择的文件</h3>
          <div class="file-item" v-for="(file, index) in files" :key="index">
            <div class="file-info">
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">{{ formatFileSize(file.size) }}</span>
            </div>
            <button class="remove-btn" @click="removeFile(index)">移除</button>
          </div>
        </div>

        <div class="controls">
          <button class="btn" @click="clearFiles">清空文件列表</button>
          <button class="btn primary" @click="uploadFiles" :disabled="files.length === 0">上传文件</button>
        </div> -->
      </div>
      <!-- 拖尾元素 -->
      <div
        v-for="trail in trails"
        :key="trail.id"
        class="trail"
        :class="trail.type"
        :style="{
          left: trail.x + 'px',
          top: trail.y + 'px',
          width: trail.size + 'px',
          height: trail.size + 'px',
          '--trail-color': trail.color
        }"
      ></div>
    </template>
    <aiParseLoad v-if="isLoading" ref="parseLoading" @close="isLoading = false" />
  </div>
</template>

<script>
import axios from 'axios'
import { axiosBase } from '@/api/api'
import { defineAsyncComponent } from 'vue'
import util from '@/api/util'
export default {
  name: 'aiDropUpload',
  props: {
    approvalId: [String, Number],
    aiTips: String,
    importType: String,
    visible: Boolean,
    onConfirm: Function,
    onCancel: Function
  },
  data() {
    return {
      isDragOver: false,
      files: [],
      trails: [],
      trailId: 0,
      trailColors: [
        '#6ee7ff', '#a855f7', '#ec4899', '#10b981',
        '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'
      ],
      lastDragTime: 0, // 用于限制拖拽时拖尾的创建频率
      dragTrailInterval: 50, // 拖拽时创建拖尾的最小间隔(毫秒)
      isLoading: false,
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
    }
  },
  components: {
    aiParseLoad: defineAsyncComponent(() => import('./aiParseLoad'))
  },
  methods: {
    close () {
      this.onCancel()
    },
    handleDragOver(event) {
      this.isDragOver = true
      // 在拖拽时也创建拖尾效果
      this.createTrailOnDrag(event)
    },

    handleDragLeave() {
      this.isDragOver = false
    },

    handleDrop(event) {
      console.log('松开')
      this.isDragOver = false
      this.isLoading = true
      const droppedFiles = event.dataTransfer.files

      if (droppedFiles.length > 0) {
        // 将文件添加到文件列表
        // for (let i = 0; i < droppedFiles.length; i++) {
        //   this.files.push(droppedFiles[i])
        // }
        this.uploadFile(droppedFiles[0])
        // 创建拖放成功的视觉反馈
        this.createDropEffect(event.clientX, event.clientY)
      }
    },
    // 普通鼠标移动时的拖尾效果
    createTrail(event) {
      this.createTrailAtPosition(event.clientX, event.clientY, 'normal')
    },

    // 拖拽文件时的拖尾效果
    createTrailOnDrag(event) {
      // 限制创建频率，避免拖尾过多
      const now = Date.now()
      if (now - this.lastDragTime < this.dragTrailInterval) {
        return
      }
      this.lastDragTime = now

      this.createTrailAtPosition(event.clientX, event.clientY, 'drag')
    },

    createTrailAtPosition(x, y, type) {
      // 根据类型设置不同的大小
      let size
      switch(type) {
        case 'drag':
          size = Math.random() * 12 + 8  // 拖拽时的拖尾更大
          break
        case 'drop':
          size = Math.random() * 15 + 10  // 拖放时的拖尾最大
          break
        default:
          size = Math.random() * 8 + 4   // 普通拖尾
      }

      const color = this.trailColors[Math.floor(Math.random() * this.trailColors.length)]

      const trail = {
        id: this.trailId++,
        x: x,
        y: y,
        size: size,
        color: color,
        type: type
      }

      this.trails.push(trail)

      // 限制拖尾数量
      if (this.trails.length > 30) {
        this.trails.shift()
      }

      // 自动移除拖尾
      setTimeout(() => {
        this.removeTrail(trail.id)
      }, 1000)
    },

    createDropEffect(x, y) {
      // 创建多个拖尾元素作为视觉反馈
      for (let i = 0; i < 15; i++) {
        setTimeout(() => {
          this.createTrailAtPosition(x, y, 'drop')
        }, i * 30)
      }
    },

    removeTrail(id) {
      const index = this.trails.findIndex(trail => trail.id === id)
      if (index !== -1) {
        this.trails.splice(index, 1)
      }
    },

    removeFile(index) {
      this.files.splice(index, 1)
    },

    clearFiles() {
      this.files = []
    },

    uploadFiles() {
      // 这里可以添加实际上传逻辑
      alert(`准备上传 ${this.files.length} 个文件`)
      // 模拟上传成功效果
      this.createUploadEffect()
    },

    createUploadEffect() {
      // 创建上传成功的视觉反馈
      const container = document.querySelector('.file-drop-container')
      const rect = container.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2

      for (let i = 0; i < 20; i++) {
        setTimeout(() => {
          this.createTrailAtPosition(
            centerX + (Math.random() - 0.5) * 200,
            centerY + (Math.random() - 0.5) * 200,
            'upload'
          )
        }, i * 50)
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    // 单个文件上传
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await axios.post(`${util.apiUrl()}/userfile/upload?accesstoken=${this.token}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        });
        console.log('文件上传成功:', response.data);
        if (this.importType === 'file') {
          this.onConfirm(response.data)
        } else {
          this.getAiFormData(response.data)
        }
      } catch (error) {
        console.error('文件上传失败:', error);
      }
    },
    async getAiFormData(fileUrl) {
      if (fileUrl) {
        const params = {
          approvalId: this.approvalId,
          question: this.aiTips.replace(/<[^>]+>/g, ''),
          file: 'userfiles/' + fileUrl
        }
        const { code, data } = await axiosBase(params, '/api/getautoimportapprovaldata')
        this.$refs.parseLoading.parseCompleted()
        if (code === 0 && Array.isArray(data)) {
          this.onConfirm(data)
        } else {
          this.onCancel()
          this.$message.warning('解析文件失败，请检查上传文件是否正确！')
        }
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式保持不变，只添加新的拖尾样式 */

.file-drop-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  z-index: 9999;
  background: linear-gradient(135deg, rgba(12, 12, 46, 0.6), rgba(26, 26, 62, 0.6), rgba(12, 12, 46, 0.6));
  color: #fff;
  overflow: hidden;
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.content-area {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  transition: all 0.3s ease;
}

.content-area.drag-over {
  transform: scale(1.02);
}

.header {
  text-align: center;
  margin-bottom: 2rem;
}

h1 {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(90deg, #6ee7ff, #a855f7, #ec4899);
  -webkit-background-clip: text;
  background-clip: text;
  color: #e0e7ff;
  text-shadow: 0 0 20px rgba(110, 231, 255, 0.5);
  margin-bottom: 1rem;
}

.header p {
  font-size: 1.2rem;
  color: #c7d2fe;
  opacity: 0.9;
}

.drop-zone {
  border: 2px dashed rgba(100, 150, 255, 0.3);
  border-radius: 20px;
  padding: 11rem 2rem;
  margin: 2rem 0;
  transition: all 0.3s ease;
  background: rgba(20, 20, 40, 0.3);
  backdrop-filter: blur(10px);
}

.drop-zone.active {
  border-color: #6ee7ff;
  background: rgba(20, 20, 40, 0.5);
  box-shadow: 0 0 30px rgba(110, 231, 255, 0.2);
  transform: translateY(-5px);
}

.drop-content {
  text-align: center;
}

.drop-icon {
  margin-bottom: 1rem;
  color: #6ee7ff;
}

.drop-content h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #e0e7ff;
}

.drop-content p {
  color: #a5b4fc;
  opacity: 0.8;
}

.file-list {
  margin: 2rem 0;
}

.file-list h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: #e0e7ff;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(30, 30, 60, 0.5);
  border-radius: 10px;
  margin-bottom: 0.5rem;
  border-left: 3px solid #6ee7ff;
}

.file-info {
  display: flex;
  flex-direction: column;
}

.file-name {
  font-weight: 500;
  margin-bottom: 0.3rem;
}

.file-size {
  font-size: 0.9rem;
  color: #a5b4fc;
  opacity: 0.7;
}

.remove-btn {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 5px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.remove-btn:hover {
  background: rgba(239, 68, 68, 0.3);
}

.controls {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

.btn {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 10px;
  background: rgba(30, 30, 60, 0.7);
  color: #c7d2fe;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.btn:hover:not(:disabled) {
  background: rgba(50, 50, 90, 0.7);
  transform: translateY(-2px);
}

.btn.primary {
  background: rgba(110, 231, 255, 0.2);
  color: #6ee7ff;
  border-color: rgba(110, 231, 255, 0.3);
}

.btn.primary:hover:not(:disabled) {
  background: rgba(110, 231, 255, 0.3);
  box-shadow: 0 5px 15px rgba(110, 231, 255, 0.2);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* 拖尾元素样式 */
.trail {
  position: fixed;
  pointer-events: none;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  opacity: 0;
}

.trail.normal {
  background: radial-gradient(circle, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 70%);
  box-shadow: 0 0 10px var(--trail-color), 0 0 20px var(--trail-color);
  animation: trailFade 1s ease-out forwards;
}

.trail.drag {
  background: radial-gradient(circle, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0) 70%);
  box-shadow: 0 0 15px var(--trail-color), 0 0 30px var(--trail-color);
  animation: dragTrailFade 1.2s ease-out forwards;
}

.trail.drop {
  background: radial-gradient(circle, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 70%);
  box-shadow: 0 0 15px var(--trail-color), 0 0 30px var(--trail-color);
  animation: dropTrailFade 1.2s ease-out forwards;
}

.trail.upload {
  background: conic-gradient(from 0deg,
    rgba(110, 231, 255, 0.8),
    rgba(168, 85, 247, 0.8),
    rgba(236, 72, 153, 0.8),
    rgba(110, 231, 255, 0.8));
  box-shadow: 0 0 20px var(--trail-color);
  animation: uploadTrailFade 1.5s ease-out forwards;
}

/* 动画定义 */
@keyframes trailFade {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2);
  }
}

@keyframes dragTrailFade {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.5);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.5);
  }
}

@keyframes dropTrailFade {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.5);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.5);
  }
}

@keyframes uploadTrailFade {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) rotate(0deg);
  }
  50% {
    opacity: 0.7;
    transform: translate(-50%, -50%) scale(1.8) rotate(180deg);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.5) rotate(360deg);
  }
}
.el-icon-close {
  font-size: 28px;
  color: #FFF;
  margin-left: 10px;
  cursor: pointer;
}
</style>
